var React = require('react');

function Symbol2 (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"id":"Rectangle_34852","data-name":"Rectangle 34852","width":"40","height":"40","rx":"20","fill":"#bdff3b","key":0}),React.createElement("path",{"id":"Path_16129","data-name":"Path 16129","d":"M602.158,404.465l-.267,1.507a3.023,3.023,0,0,0-2.995-1.66c-2.613,0-5.055,2.1-5.646,5.455s1.106,5.494,3.72,5.494a4.619,4.619,0,0,0,3.239-1.3l.265.089-.185,1.043a2.577,2.577,0,0,1-2.652,2.441c-1.125,0-1.831-.515-1.907-1.316h-3.223c-.172,2.537,1.6,4.139,4.788,4.139a6.081,6.081,0,0,0,6.256-5.265l1.869-10.625Zm-5.589,5.3a2.924,2.924,0,0,1,2.785-2.613c1.24,0,2.175.934,1.869,2.632a2.96,2.96,0,0,1-2.8,2.632C597.2,412.419,596.264,411.465,596.569,409.767Z","transform":"translate(-578.957 -392.332)","key":1})]);
}

Symbol2.defaultProps = {"id":"symbol2","width":"40","height":"40","viewBox":"0 0 40 40"};

module.exports = Symbol2;

Symbol2.default = Symbol2;
